import React from "react";
import { CheckBox } from "react-native";

export default class CustomCheckBox extends React.Component {
  render() {
    return <CheckBox {...this.props} />;
  }
}
